  <product-chooser #productChooser
  ></product-chooser>
